module.exports = __webpack_public_path__ + "img/rock-big-03.0119f357.png";